import React from 'react'
import PropTypes from 'prop-types'

import Spinner from '../../../sharedLegacy/components/SpinnerComponent/SpinnerComponent'

const AudienceFoyerLoaderComponent = ({ children, isLoading = false }) => {
  return isLoading ? <Spinner /> : children
}

AudienceFoyerLoaderComponent.propTypes = {
  children: PropTypes.node.isRequired,
  isLoading: PropTypes.bool,
}

export default AudienceFoyerLoaderComponent
